module.exports = {
	"collapsed": "See a message from <span class=\"{repClass}\">{repFirstName}</span>, your trade specialist.",
	"expanded": [
		"Hi, this is {repFirstName}, your trade specialist. Please do not hesitate to reach out if I can be of assistance with anything from sourcing to pricing to shipping. I am available Monday through Friday from 9 am to 5 pm ET.",
		"Enjoy shopping!",
		"Sincerely,"
	]
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/components/TradeWelcomeMessage/tradeWelcomeMessageCopy.json
// module id = 770
// module chunks = 4 6 8 9 12 22